/**
 * 获取当前用户是否有某一操作权限
 * @param {string} purview 需要的权限
 * @param {array} privilegeList 当前用户支持的权限列表
 */
export const canUsePermission = (purview, privilegeList = []) => {
  if (privilegeList.indexOf(purview) >= 0) {
    return true;
  }
  return false;
};
